import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { formatDate } from "utils/Utils";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { toCamelCase } from "utils/Utils";
import { formatAmount } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";
import { productTypeNames } from "assets/properties/properties";
import FindProductType from "helper/FindProductType";

const Scheme = ({props, featureFlag}) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "code", label: "Code" },
    { id: "name", label: "Name" },
    { id: "channel", label: "Channel" },
    { id: "graceday", label: "Grace Days" },
    { id: "minamount", label: "Min Amount" },
    { id: "maxamount", label: "Max Amount" },
    { id: "tenure", label: "Tenure" },
    { id: "frequency", label: "Frequency" },
    { id: "ltv", label: "Ltv(%)" },
    { id: "interest", label: "Annual Rate Max" },
    { id: "action", label: "Actions" },
  ]);
  const [productTypeError, setProductTypeError]=useState(false)
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [rawData, setRawData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteSchemeId, setDeleteSchemeId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const enablePersonalLoanFlag = parseAndSetFlag(featureFlag?.enablePersonalLoanFlag)
  const [productType, setProductType]=useState("")
const [productTypeList, setProductTypeList]=useState([])
  const handlegoldrateSubmit = async () => {
    navigate(`/coreservice/loanSchemeCreate`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);
  useEffect(()=>{
    if(productType){
        GetData()
    }
  },[productType])

  const queryParams = () =>{
    if(enablePersonalLoanFlag && productType === ""){
      return `?productType=${productTypeNames?.personalLoan}`
    }else if (productType){
     return `?productType=${productType}`
    }else{
       return ''
    }
  }
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: `${endpoint.ADMIN_LOANSCHEME_FINDALL}${queryParams()
      }`,
      authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
          FindProductType(apiHandler,endpoint,authToken,setProductTypeList, setProductType)
      parseIndicatorData(result?.data);
    }
  };
  // parseindiadata function
  const parseIndicatorData = (data) => {
    let reportData = [];

    data.forEach((LoanScheme, index) => {
      let row = {
        code: LoanScheme?.code,
        name: LoanScheme?.name,
        channel: LoanScheme?.schemeChannel,
        graceday: LoanScheme?.graceDays,
        minamount: formatAmount(LoanScheme?.minLoanAmount),
        maxamount: formatAmount(LoanScheme?.maxLoanAmount),
        tenure: LoanScheme?.tenureInMonths,
        frequency: toCamelCase(LoanScheme?.frequency),
        ltv: LoanScheme?.ltvPercentage,
        interest: LoanScheme?.annualInterestRateMax,
        action: getIcons(LoanScheme?.code, LoanScheme?.id),
        viewCode:LoanScheme?.code,
      };
      reportData.push(row);
    });
    setSelectedTableData(reportData);
  };

  const getIcons = (code, id) => {
    return (
      <>
        <IconButton
          aria-label="Edit scheme"
          onClick={(e) => {
            e.stopPropagation();
            onClickUpdateData(code)
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Scheme"
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(id)
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };

  // editing function
  const onClickUpdateData = (code) => {
    navigate(`/coreservice/loanSchemeCreate/` + code);
  };

  const onClickViewData = (code)=>{
    navigate(`/coreservice/loanScheme-createview/` + code );
  }
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Loan Scheme");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteSchemeId(id);
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteSchemeId("");
  };
  const handlePositiveResponse = async () => {
    const schemeId = deleteSchemeId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete User
    const URL =
      endpoint.BASE_URL_STAGING + "/" + endpoint.ADMIN_LOANSCHEME_DELETE;
    const res = await axios.delete(URL + schemeId, {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });
    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete Loan Scheme is successful", true);
      GetData();
    }
  };
  console.log(productType,'ajksdhkahsdkjh');
  
  // serach function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      return (
        row.name.toLowerCase().includes(val.toLowerCase()) ||
        row.schemeChannel.toLowerCase().includes(val.toLowerCase()) ||
        row.code.toLowerCase().includes(val.toLowerCase()) ||
        row.frequency.toLowerCase().includes(val.toLowerCase()) ||
        createDate.toLowerCase().includes(val.toLowerCase()) ||
        updatedDate.toLowerCase().includes(val.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Scheme"
          button1="Create Scheme"
          button1click={handlegoldrateSubmit}
          onSearchChange={onSearchChange}
          searchLabel="Search For Loan Scheme"
          search
          {...productTypeList.length > 1 && {
            select1: productType,
            select1Label: "Select Product Type",
            setSelect1: setProductType,
            select1Data: productTypeList,
            setError: setProductTypeError
          }}
          error={productTypeError}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable 
        columns={tableColumns} 
        rows={selectedTableData}            
         onClickViewData={onClickViewData}
            clickable
            />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

Scheme.propTypes = {
  classes: PropTypes.object,
};

export default Scheme;